let isMobile = window.matchMedia('(max-width: 641px)').matches;

window.onload = function() {
    // Collapses
    document.querySelectorAll('.collapse').forEach((element) => {
        new Collapse(element);
    });
};

/* Remove gravity forms tab index*/
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.gform_wrapper [tabindex]').forEach(el => {
        el.removeAttribute('tabindex');
    });
});
//# sourceMappingURL=main.js.map
